import request from "@/lib/api/handler";

import { useAuth0 } from "@auth0/auth0-react";
import { useMutation } from "@tanstack/react-query";

import { QueryKeys, useInvalidateQuery } from "@/queries/utils";

export const useConfirmCheckout = () => {
  const invalidate = useInvalidateQuery();
  const { getAccessTokenSilently } = useAuth0();

  const { mutate, isPending, error } = useMutation({
    mutationFn: async ({ sessionId }: { sessionId: string }) => {
      const token = await getAccessTokenSilently();

      return request<{
        checkoutComplete: boolean;
        jobOpeningId: string;
        candidateStatusId: string;
      }>({
        method: "POST",
        path: "/api/payment/checkout/confirm",
        token,
        body: JSON.stringify({ sessionId }),
      });
    },
    onSuccess: async ({ jobOpeningId }) => {
      await invalidate(QueryKeys.companyOpportunities);
      await invalidate(QueryKeys.companyOpportunity(jobOpeningId));
    },
  });

  return {
    confirmCheckout: mutate,
    isConfirmingCheckout: isPending,
    confirmCheckoutError: error,
  };
};
